import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Preview = lazyLoad(
  () => import('./index'),
  module => module.default,
  {
    fallback: <LoadingIndicator />,
  },
);
